import _ from 'underscore';
import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';
import { withScope, QueryParam, $current } from '@bingads-webui-react/scope-service';
import { GlobalMenuBase } from '@bingads-webui-react/global-menu';
import { MeControlBase, CustomMenuBase } from '@bingads-webui-react/me-control';
import { withSmartConfig, withUPConfig } from '@bingads-webui-react/global-smart-menu';
import { WaterfallFilterType } from '@bingads-webui/filter-commons';
import { withGlobalFilter } from '@bingads-webui-react/global-filter-context';
import { withSettingsConsumer } from '@bingads-webui-react/settings-context';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { renderPageSearch } from '@bingads-webui-react/global-search';
import { renderHelpLibrarySearch } from '@bingads-webui-react/global-search-help-library';
import { renderCampaignSearch } from '@bingads-webui-campaign-react/campaign-entity-search';
import { renderCopilotSearchWithCopilot } from '@bingads-webui/global-search-copilot';
import { DummyCustomerAccountSelector } from '@bingads-webui-react/customer-account-selector';
import { DummyCustomerSelector } from '@bingads-webui-react/customer-selector';
import { ACCOUNT_MODE } from '@bingads-webui-campaign/campaign-ui-common';
import { withLayoutContext } from '@bingads-webui-react/app-layout-container';
import {
  convertFilteredCampaignTypeToFilter
} from '@bingads-webui-campaign-react/shell-ui-common';
import {
  withSiteMap,
  processorSet,
  processor,
  CampaignType,
  withCampaignSiteMap,
  siteMapPropType,
} from '@bingads-webui-campaign-react/with-site-map';
import { GlobalMenuEntityBar } from '@bingads-webui-campaign-react/summary-bar';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { withHotKeys, ShortcutType } from '@bingads-webui-react/hot-keys';
import { withPageReadyAsync } from '@bingads-webui-react/with-page-ready';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { isHamburgerVisibleStore } from '@bingads-webui-campaign-react/main-menu-container';
import { withStateStore } from '@bingads-webui/with-state-store';
import { onToggleCopilot, toggleCopilotWithMSASignInPopup } from '@bingads-webui-react/msa-copilot-common';
import { setClarityTag } from '@bingads-webui-universal/clarity';
import { getHeaderHide, isBillingLinkPermission } from '@bingads-webui/multi-agency-utils';
import { isCopilotRegionRestricted } from '@bingads-webui-react/copilot-utils';

import { DelayedNotificationsBar } from './delayed-notifications-bar';

const DelayedReportsV4Bar = withPageReadyAsync(() =>
  import(/* webpackMode: 'eager' */'@bingads-webui-campaign/reports-v4-bar/index-uinext')
    .then(({ ReportsV4DropDown }) => ({ default: ReportsV4DropDown })));

class GlobalMenuWrapperInternal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.perfMarker = this.props.appPerfMarker.createChild('global-menu-perf', { autoEnd: true });
    this.perfMarker.willInit();
    this.globalHelpRef = React.createRef();

    const {
      permissions, serverContext, scope, settingsContext,
    } = props;
    let wrappedGlobalMenu = withSmartConfig(GlobalMenuBase);
    const accountMode = _.get(serverContext, ['CurrentAccount', 'AccountMode']);
    const aid = _.get(scope, ['values', 'aid']);
    const isUnifiedSmartMode = _.get(permissions, 'IsUnifiedSmartMode');
    if (isUnifiedSmartMode || (!!aid && accountMode === ACCOUNT_MODE.UNIFIED_SMART)) {
      // Check at both customer level and account level
      // Customer level: all account are UnifiedSmart
      // Account level: current account is UnifiedSmart
      wrappedGlobalMenu = withUPConfig(GlobalMenuBase);
    }

    this.GlobalMenuEmbeded = withSettingsConsumer(withSiteMap(wrappedGlobalMenu, [processor.processPath, ...processorSet.basic]));

    // To save performance by only loading the real CustomerAccountSelector component after page is ready
    this.DelayedAccountSelector = withPageReadyAsync(() =>
      Promise.all([
        import(/* webpackMode: 'eager' */'@bingads-webui-react/customer-account-selector'),
        import(/* webpackMode: 'eager' */'@bingads-webui-react/hierarcy-tree-view-with-rcid-storage'),
      ]).then(([
        { CustomerAccountSelectorTreeView },
        { TreeViewWithRCIDStorage },
      ]) => ({
        default: TreeViewWithRCIDStorage(CustomerAccountSelectorTreeView),
      })), DummyCustomerAccountSelector);

    this.DelayedCustomerSelector = withPageReadyAsync(() =>
      import(/* webpackMode: 'eager' */'@bingads-webui-react/customer-selector')
        .then(({ CustomerSelector }) => ({ default: CustomerSelector })), DummyCustomerSelector);
    const adsCopilotScenario = props.instrumentation.createScenario({
      scenarioName: 'AdsCopilot',
    });
    this.adsCopilotLogger = adsCopilotScenario.createActivity('UserAction');
    this.isCampaignPageAccessible = _.get(permissions, 'IsInternalUser') || !isBillingLinkPermission(settingsContext);

    this.state = { isAdsCopilotRegionRestricted: false };
  }

  componentDidMount() {
    isCopilotRegionRestricted({
      feature: 'Chat',
      logger: this.adsCopilotLogger,
      permissions: this.props.permissions,
      serverContext: this.props.serverContext,
    }).then((isRestricted) => {
      this.setState({ isAdsCopilotRegionRestricted: isRestricted });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.hotKey === 'shift+h' && prevProps.count !== this.props.count) {
      if ($('#apexHelpContainer').is(':visible')) {
        $('#apexHelpContainer .close_button').click();
      } else {
        this.globalHelpRef.current.click();
      }
    }
  }

  onLogoClick = () => {
    const {
      scope, updateWaterfallFilter,
    } = this.props;
    if (_.isFunction(updateWaterfallFilter)) {
      updateWaterfallFilter({
        filterType: WaterfallFilterType.CampaignType,
        filter: convertFilteredCampaignTypeToFilter(CampaignType.All),
      });
    }

    scope.set({
      cid: $current,
      aid: $current,
      uid: $current,
    });

    // Don't specify a page, this should make page menu use the default landing page
    scope.save('/campaign/vnext');
  };

  onCopilotClick = ({ customizedEvent, forceOpen } = {}) => {
    const { permissions, serverContext } = this.props;
    const username = _.get(serverContext, ['CurrentUser', 'Name']);
    const localeId = _.get(serverContext, ['CurrentUser', 'LocaleID']);
    const isAADUser = _.get(serverContext, ['IsAADUser']);
    const isAppBasedAuthEnabled = _.get(permissions, ['dynamic', 'AdsCopilotAppBasedAuth']);
    const isNewLogo = permissions?.dynamic?.AdsCopilotUxImprovements;

    const toggleCopilot = toggleCopilotWithMSASignInPopup({
      userName: username,
      localeId,
      isAADUser,
      isAppBasedAuthEnabled,
      toggleCopilot: (mode) => {
        this.adsCopilotLogger.trace(`[Copilot] Toggle copilot via Copilot button on header, mode: ${mode} isNewLogo:${isNewLogo}`);
        onToggleCopilot({
          changeLayout: this.props.changeLayout,
          mode,
          logger: this.adsCopilotLogger,
          customizedEvent,
        });
      },
      logger: this.adsCopilotLogger,
    });
    const copilotMode = _.chain(this.props.layoutConfig).result('copilot').result('mode', 'hidden').value();
    const nextMode = (forceOpen || copilotMode === 'collapsed') ? 'expanded' : 'collapsed';
    toggleCopilot(nextMode);
  };

  render() {
    const {
      appPerfMarker,
      serverContext,
      permissions,
      scope,
      instrumentation,
      onHamburgerClicked,
      siteMap: campaignSiteMap,
      settingsContext,
    } = this.props;
    const {
      CurrentAccount,
      Urls,
      CurrentUser,
      Omniture,
      PageTrackingId,
      IsProdEnv,
    } = serverContext;
    const globalMenuScenario = instrumentation.globalMenuScenario.create();
    const globalMenuActivity = globalMenuScenario.globalMenuActivity.create();
    const feedbackScenario = instrumentation.feedbackScenario.create();
    const logger = feedbackScenario.feedbackActivity.create();
    const feedbackLogger = {
      log: (info) => {
        logger.trace(info);
      },
    };
    const { Email } = CurrentUser;
    const { SessionId } = Omniture;
    const feedbackProps = {
      isTestEnv: !IsProdEnv,
      feedbackLogger,
      email: Email,
      pageId: PageTrackingId,
      sessionId: SessionId,
      hideFeedback: permissions.IsReadOnlyUser,
    };
    const {
      Id, Name, AccountNumber, AdvertiserCustomerID,
    } = CurrentAccount;
    const account = {
      Id,
      Name,
      AccountNumber,
      ParentCustomerId: AdvertiserCustomerID,
    };
    const supportUrl = Urls.RootUIUrl.replace(/^https:\/\//, 'https://internal.');
    const campaignSearchEnabled = permissions && permissions.dynamic && permissions.dynamic.CampaignSearch;
    const accountIdEnabled = scope.values && scope.values.aid;
    const renderSearchResults = [];
    if (!this.state.isAdsCopilotRegionRestricted) {
      const isNewLogo = permissions?.dynamic?.AdsCopilotUxImprovements;
      renderSearchResults.push(renderCopilotSearchWithCopilot(this.onCopilotClick, isNewLogo));
    }
    renderSearchResults.push(renderPageSearch);
    renderSearchResults.push(renderHelpLibrarySearch);
    if (campaignSearchEnabled && accountIdEnabled && this.isCampaignPageAccessible) {
      renderSearchResults.push(renderCampaignSearch);
    }

    const renderHelpPanel = () => (
      <div style={{ display: 'none' }}>
        <a ref={this.globalHelpRef} className="HelpTopic" href="/#" > </a>
      </div>
    );

    const hide = {
      mmc: false,
      assetLibrary: !_.result(permissions.dynamic, 'AssetLibraryGlobalMenu', false),
      copilot: this.state.isAdsCopilotRegionRestricted,
      ...(!_.get(permissions, 'IsInternalUser') && getHeaderHide(settingsContext)),
    };

    setClarityTag({ NavigationRefresh: 'false' });

    return (
      <React.Fragment>
        <this.GlobalMenuEmbeded
          showEntityBreadcrumb={_.result(permissions.dynamic, 'AppBarBreadcrumb', false) && _.findWhere(campaignSiteMap, { selected: true })}
          entityBreadcrumbProps={{
            appPerfMarker,
          }}
          EntityBreadcrumb={GlobalMenuEntityBar}
          account={account}
          serverContext={serverContext}
          supportUrl={supportUrl}
          onLogoClick={this.onLogoClick}
          renderSearchResults={renderSearchResults}
          NotificationsBar={DelayedNotificationsBar}
          ReportsV4Bar={DelayedReportsV4Bar}
          hide={hide}
          feedbackProps={feedbackProps}
          AccountSelector={this.DelayedAccountSelector}
          MeControl={MeControlBase}
          CustomMenu={CustomMenuBase}
          CustomerSelector={this.DelayedCustomerSelector}
          perfMarker={this.perfMarker}
          showPrideLogo={_.result(permissions.dynamic, 'PrideLogo', false)}
          globalMenuActivity={globalMenuActivity}
          isAccountSummary={!accountIdEnabled}
          onHamburgerClicked={this.props.isHamburgerVisible ? onHamburgerClicked : null}
          isMainNavPanelMode={this.props.isPanelMode}
          showBackToCampaignButton={this.isCampaignPageAccessible}
          onCopilotClick={this.onCopilotClick}
        />
        {renderHelpPanel()}
      </React.Fragment>
    );
  }
}

GlobalMenuWrapperInternal.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({}),
    Urls: PropTypes.shape({}),
  }).isRequired,
  instrumentation: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({}),
  }).isRequired,
  settingsContext: PropTypes.shape({}).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  updateWaterfallFilter: PropTypes.func.isRequired,
  hotKey: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  appPerfMarker: perfMarkerPropTypes.isRequired,
  onHamburgerClicked: PropTypes.func,
  isHamburgerVisible: PropTypes.bool.isRequired,
  isPanelMode: PropTypes.bool.isRequired,
  siteMap: siteMapPropType.isRequired,
  changeLayout: PropTypes.func.isRequired,
  layoutConfig: PropTypes.shape({
    nav: PropTypes.shape({
      mode: PropTypes.string,
    }),
  }).isRequired,
};

GlobalMenuWrapperInternal.defaultProps = {
  onHamburgerClicked: null,
};

export const GlobalMenuWrapper =
  withSettingsConsumer(withCampaignSiteMap(withStateStore(withPermissions(withInstrumentation(withHotKeys(withServerContext(withScope(withGlobalFilter(withLayoutContext(GlobalMenuWrapperInternal)))), ShortcutType.ShowHideHelp))), isHamburgerVisibleStore, store => ({
    isHamburgerVisible: store.state.isHamburgerVisible,
    isPanelMode: store.state.isPanelMode,
  }))));
